module.exports = __webpack_public_path__ + "static/media/opensans-lightitalic-webfont.772fac09.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-lightitalic-webfont.woff2
// module id = 1015
// module chunks = 0